import { render, staticRenderFns } from "./TemplateIndexComponent.vue?vue&type=template&id=4a4de8b3&scoped=true&"
import script from "./TemplateIndexComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateIndexComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateIndexComponent.vue?vue&type=style&index=0&id=4a4de8b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4de8b3",
  null
  
)

export default component.exports